import React, { useState } from 'react'
import StatsCards from './StatsCards';
import BarChart from './BarChartRender';
import DoughnutChart from './DoughnutChart';

// 1. Total acres sprayed
// 2. Farmers enrolled 
// 3. Villages covered
// 4. Chemicals used (in Lit)
 
// Weekly, monthly sprayed (state wise)
// State wise area in bar graph
// stacked bar graph showing total area and area sprayed

const Analytics = ({combinedData}) => {
	// total area covered.
	const [data, setData] = useState(combinedData);
	const totalArea = combinedData.reduce((acc, curr) => acc + (curr.areaSprayed || 0), 0);
	const totalFarmers = combinedData.length;
	const uniqueVillages = [...new Set(combinedData.map((f) => f.village))].length;

	const extractDosageNumber = (dosage) => {
		if (!dosage) return 0;

		// Extract ALL numbers (works for: "250 ml , 250 ml")
		const numbers = dosage.match(/\d+(\.\d+)?/g);
		if (!numbers) return 0;

		// Sum all numeric values
		return numbers.reduce((sum, num) => sum + parseFloat(num), 0);
	};

	const chemicalUsed = combinedData.reduce(
		(acc, curr) => acc + extractDosageNumber(curr.dosage),
		0
	);

	const filter = (value) => {

		switch(value){

			case 'all' : setData(combinedData); break;

			case 'last-week': 
			const oneWeekAgo = new Date();
			oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
			setData(
				combinedData.filter(log => new Date(log.dateOfSpraying) >= oneWeekAgo)
			);
			break;

			case 'last-month' : 
			const oneMonthAgo = new Date();
			oneMonthAgo.setDate(oneMonthAgo.getDate() - 30);
			setData(
				combinedData.filter(log => new Date(log.dateOfSpraying) >= oneMonthAgo)
			);
			break;

			case 'default' :  setData(combinedData); break;
			
		}
	};

  return (
	<div>
		<StatsCards 
			totalArea={totalArea} 
			totalFarmers={totalFarmers} 
			uniqueVillages={uniqueVillages} 
			chemicalUsed={chemicalUsed} 
		/>
		<div className='md:flex md:justify-between gap-5 mt-5'>
		  <BarChart combinedData={data} filter = {(value) => filter(value)}/>
		  <DoughnutChart combinedData={combinedData}/>
		</div>
	</div>
  )
}

export default Analytics